export class Jugador {
  _id:               string;
  nombre:            string;
  apellidoPaterno:   string;
  apellidoMaterno:   string;
  avatar:            string;
  clave:             string;
  correo:            string;
  contrasenia:       string;
  estatus:           string;
}



// WEBPACK FOOTER //
// ./src/dominio/jugador.ts